import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import qs from 'qs'

// 非生产环境 && 开启代理, 接口前缀统一使用[/api]前缀做代理拦截!
const BASE_URL = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_SERVER_URL : process.env.VUE_APP_SERVER_URL
const Mes = (val, time = 3000) => {
  Message({
    message: val,
    type: 'error',
    duration: time
  })
}

const http = axios.create({
  timeout: 100000, // 赶超时间
  headers: {
    'Content-Type': 'application/json' // 默认请求头
  },
  baseURL: BASE_URL
})

http.interceptors.request.use(
  config => {
    const TOKEN = window.sessionStorage.getItem('token') || ''
    const TYPE = config.method

    config.headers.userToken = TOKEN

    if (
      TYPE === 'post' &&
      config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
    ) {
      // post请求参数处理
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  async res => {
    const CODE = res.data.code
    if (CODE === 403) {
      Mes('登录过期，请重新登录')
      await store.dispatch('user/resetAuth')
      router.push({ path: '/login' })
    } else if (CODE !== 200) {
      Mes(res.data.msg)
    }
    return Promise.resolve(res)
  },
  error => {
    if (error.response.status === 404) {
      Mes('404 找不到路径' + error.response.config.url)
    } else {
      Mes(error.response.data.msg)
    }
    return Promise.reject(error)
  }
)

export default http
